'use strict';

/**
  * Konfiguration der Routen
  * @namespace v3sWbtPlayerApp:route
  */

/**
 * Konfiguration des Verhaltens der Routen
 * @class route_general
 * @memberOf v3sWbtPlayerApp:route
 */
angular.module('v3sWbtPlayerApp').run(["$rootScope", "$state", "$stateParams", "$location", "$window", "v3sWbtDataService", "v3sLog", "$q", "v3sServiceFinder", "v3sBrowserInfoService", "$timeout", "v3sViewportViewerService", function ($rootScope, $state, $stateParams, $location, $window, v3sWbtDataService, v3sLog, $q, v3sServiceFinder, v3sBrowserInfoService, $timeout, v3sViewportViewerService) {
    var forwardTimer = null;

    //init v3sAnnotationService
    var v3sAnnotationService = v3sServiceFinder.get("v3sAnnotationService");

    //init interface service
    var v3sInterfaceService = v3sServiceFinder.get("v3sInterfaceService");

    //init ViewportChecker
    var v3sViewportChangeCheckerService = v3sServiceFinder.get("v3sViewportChangeCheckerService");

    //init LzDebugger
    var v3sLzDebuggerService = v3sServiceFinder.get("v3sLzDebuggerService");

    //init v3sTestingLogService
    var v3sTestingLogService = v3sServiceFinder.get("v3sTestingLogService");

    $rootScope.$state = $state;
    $rootScope.$stateParams = $stateParams;

    $rootScope.mobileview = {
        url: $location.absUrl(),
        visible: false,
        cancel: function () {
            $rootScope.mobileview.visible = false;
            loadLocation();
        }
    };

    //TODO: im Jahr 2019 MobileView komplett löschen 
    if (false && v3sBrowserInfoService.isMobileFrame() && $rootScope.mobileview.url.indexOf("mode=scorm12") > 0) { //Deaktivieren wegen Refresh-Problem: Lernstand geht bei Multi-SCOs verloren
        $rootScope.mobileview.visible = true;
        $state.go("mobileview");
    }

    var isWbtStarted = function () {
        var path = $location.path();
        return (path === "/" || path === "" || Object.keys($stateParams).length == 0);
    };

    /**
    * Konfiguriert das Starten der Anwendung (ScormData-API, Startpunkt)
    * @function loadLocation
    * @memberOf v3sWbtPlayerApp:route.route_general
    * @listens $locationChangeStart
    */
    var loadLocation = function () {
        if (isWbtStarted()) { //Lade WBT-Daten

            v3sLog.debug("WBT is loading...");

            if ($rootScope.mobileview.visible) {
                $rootScope.mobileview.url = $location.absUrl();
                v3sLog.debug("Mobile View Location");

            } else {

                //load angular route params
                var initParams = $location.search();

                v3sLog.debug("InitParams", initParams);

                //load iframe or document params
                var urlParams = "";
                if (!!window.frameElement) {
                    urlParams = window.frameElement.src;
                }

                if (!urlParams) {
                    urlParams = document.location.href;
                }

                v3sLog.debug("URL", urlParams);

                if (!!urlParams) {
                    urlParams = urlParams.substring(urlParams.indexOf("?") + 1);
                    urlParams = urlParams.split("&");
                    for (var i = 0; i < urlParams.length; i++) {
                        var param = urlParams[i].split("=");
                        initParams[param[0]] = param[1];
                    }
                }

                v3sLog.debug("MergedParams", initParams);

                if (!!initParams.viewport) {
                    v3sViewportViewerService.activate();
                }

                if ((initParams.mode === "scorm12" || initParams.mode === "scorm2004") && v3sWbtDataService.isScoChangeAllowed(initParams.sco)) {
                    v3sWbtDataService.close(true); //falls ein WBT/SCO schon geladen ist, dann schließe es
                } else if (!!initParams.lzdebug && v3sLzDebuggerService) {
                    v3sLzDebuggerService.activateForOneRequest(initParams.lzdebug.split("#")[0]);
                }

                if (v3sWbtDataService.isInitAllowed()) { //falls kein WBT/SCO initialisiert ist
                    $timeout(function () {
                        v3sWbtDataService.init(initParams.mode, initParams.sco).then(function () {
                            var toParams = {};
                            if (v3sWbtDataService.isLmsMode()) {
                                toParams.mode = initParams.mode; // falls ein Lesezeichen erstellt wird, dann soll beim Aufrug Fehlermeldung "Keine LMS-API gefunden" kommen
                                var api = v3sWbtDataService.getScormApi();
                                var entry = api.getEntry();
                                if (!!entry) {
                                    initParams.entry = entry;
                                }

                            } else {
                                var path = $location.path();
                                if (!initParams.sco && path.indexOf("/sco/") == 0) {
                                    initParams.sco = path.replace("/sco/", "");
                                }
                            }

                            toParams.scoId = !!initParams.sco ? initParams.sco : v3sWbtDataService.getWbt().getFirstChild().id;
                            toParams.entry = initParams.entry;

                            v3sLog.debug("GoTo", toParams);
                            $state.go("main.sco", toParams);
                        });
                    });
                } else {
                    v3sLog.debug("Chancel WBT loading. WBT has already been loaded.");
                }
            }
        }
    };
    $rootScope.$on('$locationChangeStart', loadLocation);

    /**
    * Konfiguriert das Schließen der Anwendung
    * @memberOf v3sWbtPlayerApp:route.route_general
    */
    $window.onbeforeunload = function () {
        v3sWbtDataService.close(true);
    }
    $window.onpagehide = function () {
        v3sWbtDataService.close(true);
    }
    $window.onunload = function (){
        v3sWbtDataService.close(true);
    }

    /**
    * Konfiguriert das Verhalten bei fehlerhaften Routen
    * @function on
    * @memberOf v3sWbtPlayerApp:route.route_general
    * @listens $stateNotFound, $stateChangeError
    */

    $rootScope.$on('$stateNotFound', function (event, unfoundState, fromState, fromParams) {
        v3sLog.warn("stateNotFound");
        v3sLog.log(unfoundState);
    });

    $rootScope.$on('$stateChangeError', function (event, toState, toParams, fromState, fromParams, error) {
        v3sLog.warn("stateChangeError");
        v3sLog.log(toState);
        v3sLog.log(error);

        if (!!toParams.scoId) {
            $state.go("main.sco", { scoId: toParams.scoId });
        }
    });

    /**
        * Konfiguriert das Verhalten der SCO-Route: <br>
        * - bei einem Standard-SCO wird SCO-Standard-Route geladen<br>
        * - falls SCO-Eintritt / Seiten-Id nicht angegeben sind, wird erste Seite geladen<br>
        * - falls die angegebene Seite eine Sektion ist, wird die erste Seite in der Sektion geladen
        * - falls Navigation nicht erlaubt ist, wird Seitenwechsel verhindert
        * - Navigieren zwischen SCOs in SAVE-LMS
        * @function on
        * @memberOf v3sWbtPlayerApp:route.route_general
        * @listens $stateChangeStart
        */
    $rootScope.$on('$stateChangeStart', function (event, toState, toParams, fromState, fromParams, error) {
        var wbt = v3sWbtDataService.getWbt();

        if(!!forwardTimer){
            $timeout.cancel(forwardTimer);
        }

        if (!wbt) {
            toParams.readyToChange = false;
            event.preventDefault();
            return;
        } else if (!!toParams.readyToChange) {
            toParams.readyToChange = false;
            return;
        } else {
            event.preventDefault();

            var toSco, fromSco, toPage, fromPage;
            var allowExit = true,
                allowEnter = true;

            var scoId = !!toParams.scoId ? toParams.scoId : toParams.request;
            toSco = wbt.getItem(scoId);
            if (!!toSco) {

                toPage = toSco.getItem(toParams.entry);
                if (!toPage || toPage == toSco) {
                    toPage = toSco.getFirstChild();
                }

                while (!!toPage && !!toPage.getFirstChild) {
                    var newPage = toPage.getFirstChild();
                    if (toPage == newPage) {
                        break;
                    } else {
                        toPage = newPage;
                    }

                }
                allowEnter = toSco.allowEnter(toPage);
            }

            fromSco = wbt.getItem(fromParams.scoId);
            if (!!fromSco) {
                fromPage = fromSco.getItem(fromParams.entry);
                allowExit = fromSco.allowExit(fromPage, toPage);
            }

            if (allowExit !== false && allowEnter !== false) {
                $q.all([allowExit, allowEnter]).then(function (params) {

                    if (toState.name === "main.request") {
                        var scormApi = v3sWbtDataService.getScormApi();

                        if (scormApi && v3sWbtDataService.isLmsMode()) {
                            if (scormApi.goToSco(toParams.request, toParams.entry)) {
                                v3sWbtDataService.close();
                            }
                        }

                    } else {
                        var allowEnterTo = params[1];
                        if (!!allowEnterTo && !!allowEnterTo.id) {
                            toParams.entry = allowEnterTo.id;
                        } else if (toState.name === "main.sco" && toParams.entry != toPage.id) {
                            toParams.entry = toPage.id;
                        }

                        if (toParams.entry != fromParams.entry || toParams.scoId != fromParams.scoId) {
                            toParams.readyToChange = true;
                            $state.go(toState, toParams);
                        }
                    }

                });
            } else if (isWbtStarted() && allowEnter == false && toSco.isLocked()) {//Gesperrtes Item direkt aufgerufen
                toSco = wbt.getFirstChild();

                var scormApi = v3sWbtDataService.getScormApi();
                if (scormApi && v3sWbtDataService.isLmsMode()) {

                    $state.go("error", { code: 403 });
                    forwardTimer = $timeout(function () {
                        forwardTimer = null;
                        $state.go("main.request", { request: toSco.id });
                    }, 7000);
                } else {
                    $state.go("error", { code: 403 });
                    forwardTimer = $timeout(function () {
                        forwardTimer = null;
                        $state.go("main.sco", { scoId: toSco.id });
                    }, 7000);
                }
            }
        }
    });
}]);